interface ILayoutProps {
  children?: React.ReactNode;
}

function Layout({ children }: ILayoutProps): JSX.Element {
  return (
    <div
      className='relative flex h-full min-h-screen w-full flex-col bg-gray-lightest'
      onDragOver={(evt) => evt.preventDefault()}
      onDrop={(evt) => evt.preventDefault()}
    >
      {children}
    </div>
  );
}

export default Layout;
